import { useState, useEffect } from "react";
import { RiLoader4Line } from "react-icons/ri";


function Loader({ messages, interval = 10000 }) { //10 second interval
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

    useEffect(() => {
        if (!messages || messages.length === 0) return; // No messages, do nothing

        const timer = setInterval(() => {
            setCurrentMessageIndex(prev => {
                if (prev < messages.length - 1) {
                    return prev + 1;
                } else {
                    clearInterval(timer); // stop at last message
                    return prev;
                }
            });
        }, interval);

        return () => clearInterval(timer); // cleanup on unmount
    }, [messages, interval]);

    return (
        <div className="loader-wrapper" style={{ textAlign: "center" }}>
            <div style={{fill: "#ffa103"}} className="loader loader--style2" title="1">
                <RiLoader4Line style={{ enableBackground: "new 0 0 50 50", width:"90px", height:"90px" }}
                    className="loader-spinner" />
                {messages && messages.length > 0 && (
                    <p className="loader-message">
                        {messages[currentMessageIndex]}
                    </p>
                )}
            </div>

        </div>
    );
}

export default Loader;
